import classNames from 'classnames';
import React, {ReactElement} from 'react';

import {LeftArrow, PencilIcon} from '../../../../resources/Icons';
import URLS from '../../../../urls';
import Row from '../../../common/Row';
import {ProfileStatus} from '../../marketplace/types';

type Props = {
  status?: ProfileStatus;
  variant?: 'edit' | 'preview';
};

const EditYourSupplierBanner = ({status, variant = 'edit'}: Props): ReactElement => {
  return (
    <a
      className={classNames(
        'flex-none py-4 hover:bg-primary-600 hover:no-text-shadow text-sm text-white fv-outline-internal',
        variant === 'preview' ? 'bg-primary-600' : 'bg-primary-700'
      )}
      href={URLS.commonApp.supplier.about}
    >
      <div className={'w-full max-w-wider mx-auto px-sm flex flex-row items-center gap-xs'}>
        {variant === 'preview' ? (
          <>
            <LeftArrow className={'w-6 h-6'} />
            Return to the editor
          </>
        ) : (
          <>
            <PencilIcon className={'w-6 h-6'} />
            Edit your profile
          </>
        )}
        {status === 'Draft' && (
          <Row className={'grow items-center justify-end gap-4'}>
            <div className={'flex-none w-[1.5rem] h-[1.5rem] rounded-full bg-orange-100'} />
            Your supplier is a draft
          </Row>
        )}
        {status === 'In review' && (
          <Row className={'grow items-center justify-end gap-4'}>
            <div className={'flex-none w-[1.5rem] h-[1.5rem] rounded-full bg-red-200'} />
            Your supplier is in review
          </Row>
        )}
        {status === 'Published' && (
          <Row className={'grow items-center justify-end gap-4'}>
            <div className={'flex-none w-[1.5rem] h-[1.5rem] rounded-full bg-primary-300'} />
            Your supplier is published
          </Row>
        )}
      </div>
    </a>
  );
};

export default EditYourSupplierBanner;
